/**
 *  TopbarMobileMenu prints the menu content for authenticated user or
 * shows login actions for those who are not authenticated.
 */
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { bool, func, number, string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routeConfiguration';
import { propTypes } from '../../util/types';
import { Button, InlineTextButton, NamedLink, NotificationBadge } from '../../components';
import moment from 'moment';
import {
  IconBookings,
  IconPackages,
  IconSchedule,
  IconClient,
  // IconPlus,
} from '../../components/IconTopbar/IconTopbar';
import css from './TopbarMobileMenu.css';
import ImageVendorPortal from '../../assets/menuImages/venderportal.png';
import ImageVendorPortal2 from '../../assets/menuImages/venderportal2.png';
import ImageClientPortal from '../../assets/menuImages/clientprotal.png';
import ImageClientPortal2 from '../../assets/menuImages/clientprotal2.png';
import ImagebecomeVendorPortal1 from '../../assets/menuImages/becomeVendorPortal1.png';
import ImagebecomeVendorPortal2 from '../../assets/menuImages/becomeVendorPortal2.png';
import upArrow from '../../assets/upArrow.png';

const sliderSettings = {
  appendDots: dots => (
    <div
      style={{
        backgroundColor: 'transparent',
        borderRadius: '10px',
        padding: '10px',
      }}
    >
      <ul style={{ margin: '0px' }}> {dots} </ul>
    </div>
  ),
  infinite: true,
  autoplay: true,
  speed: 2000,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipeToSlide: true,
  swipe: true,
  dots: true,
  arrows: false,
  pauseOnHover: true,
};

const TopbarMobileMenu = props => {
  const {
    isAuthenticated,
    currentPage,
    currentUser,
    notificationCount,
    onLogout,
    location,
  } = props;

  // const user = ensureCurrentUser(currentUser);
  // eslint-disable-next-line
  const [isJobsBoardMenuOpen, setJobsBoardMenuOpen] = useState(false);
  const [isBecomeVendorMenuOpen, setBecomeVendorMenuOpen] = useState(false);
  const [isClientMenuOpen, setClientMenuOpen] = useState(false);
  const [isVendorMenuOpen, setVendorMenuOpen] = useState(false);
  const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);

  useEffect(() => {
    const { hash } = location;
    if (hash && hash !== '') {
      if (hash === '#clientmenu') {
        setClientMenuOpen(true);
      } else if (hash === '#vendormenu') {
        setClientMenuOpen(false);
        setVendorMenuOpen(true);
      }
    } else {
      setClientMenuOpen(false);
      setVendorMenuOpen(false);
      setJobsBoardMenuOpen(false);
    }
  }, [location]);

  let isPrivateSite = false;
  if (typeof window !== 'undefined' && !!window.sessionStorage) {
    isPrivateSite = window.sessionStorage.getItem('privateSiteUrl') ? true : false;
  }

  const signup = (
    <NamedLink name="SignupPage" className={css.signupLink}>
      <FormattedMessage id="TopbarMobileMenu.signupLink" />
    </NamedLink>
  );

  const login = (
    <NamedLink name="LoginPage" className={css.loginLink}>
      <FormattedMessage id="TopbarMobileMenu.loginLink" />
    </NamedLink>
  );

  const signupOrLogin = (
    <span className={css.authenticationLinks}>
      <FormattedMessage id="TopbarMobileMenu.signupOrLogin" values={{ signup, login }} />
    </span>
  );

  const notificationCountBadge =
    notificationCount > 0 ? <NotificationBadge count={notificationCount} /> : null;

  const onBecomeVendorMenuToggle = () => {
    setBecomeVendorMenuOpen(!isBecomeVendorMenuOpen);
    setJobsBoardMenuOpen(false);
  };
  // const onJobsBoardMenuToggle = () => {
  //   setJobsBoardMenuOpen(!isJobsBoardMenuOpen)
  //   setBecomeVendorMenuOpen(false)
  // }
  const onClientMenuToggle = () => {
    setClientMenuOpen(!isClientMenuOpen);
  };
  const onVendorMenuToggle = () => {
    setVendorMenuOpen(!isVendorMenuOpen);
  };
  const onProfileMenuToggle = () => {
    setProfileMenuOpen(!isProfileMenuOpen);
  };
  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
  };

  const svgIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 10 15" fill="none">
      <path
        d="M2.3454 0.333984L0.708008 1.97137L6.02662 7.3016L0.708008 12.6318L2.3454 14.2692L9.31301 7.3016L2.3454 0.333984Z"
        fill="#0095B3"
      />
    </svg>
  );

  const profileMenu = (
    <>
      <img className={css.profileUpArrow} src={upArrow} alt="upArrow" />
      <div className={classNames(css.menucontent, css.menuContentBorder)}>
        <div className={css.profileMenuContent}>
          <NamedLink
            className={classNames(css.profileSettingsLink, currentPageClass('ProfileSettingsPage'))}
            name="ProfileSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
          </NamedLink>
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('AccountSettingsPage'))}
            name="AccountSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.accountSettingsLink" />
          </NamedLink>
          <a className={css.yourListingsLink} href="https://probuddyblog.com/">
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.blog" />
          </a>
          {isAuthenticated && (
            <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
              <span className={css.menuItemBorder} />
              <FormattedMessage id="TopbarDesktop.logout" />
            </InlineTextButton>
          )}
        </div>
      </div>
    </>
  );

  const clientPortal = (
    <div className={css.menucontent}>
      <div className={css.whiteContainer}>
        <div className={css.menuImage}>
          <img src={ImageClientPortal} alt="ImageClientPortal" />
        </div>

        {/* <div className={css.mobMenuTitle}><FormattedMessage id="TopbarDesktop.yourAccount" /></div> */}
        <NamedLink className={css.inboxMenuLink} name="InboxPage" params={{ tab: 'orders' }}>
          <div className={css.menuItemHolder}>
            <div>
              <IconBookings />
            </div>
            <div>
              <span className={css.menuItemTitle}>
                <FormattedMessage id="TopbarDesktop.inbox" />
              </span>
              <span className={css.menuItemInfo}>
                <FormattedMessage id="TopbarDesktop.bookingsInfo" />
              </span>
            </div>
          </div>
        </NamedLink>
        <NamedLink name="InboxPage" params={{ tab: 'buyerPackages' }}>
          <div className={css.menuItemHolder}>
            <div>
              <IconPackages />
            </div>
            <div>
              <span className={css.menuItemTitle}>
                <FormattedMessage id="TopbarDesktop.yourPackages" />
              </span>
              <span className={css.menuItemInfo}>
                <FormattedMessage id="TopbarDesktop.checkBalance" />
              </span>
            </div>
          </div>
        </NamedLink>
        {!isPrivateSite && (
          <NamedLink name="InboxPage" params={{ tab: 'pro_connect_requests' }}>
            <div className={css.menuItemHolder}>
              <div>
                <IconClient />
              </div>
              <div>
                <span className={css.menuItemTitle}>
                  <FormattedMessage id="TopbarDesktop.yourProConnectRequests" />
                </span>
                <span className={css.menuItemInfo}>
                  <FormattedMessage id="TopbarDesktop.manageOrCloseRequests" />
                </span>
              </div>
            </div>
          </NamedLink>
        )}
      </div>

      {!isPrivateSite && (
        <div className={css.greyContainer}>
          <div className={css.menuSection}>
            <div className={css.menuImage}>
              <img src={ImageClientPortal2} alt="ImageClientPortal2" />
            </div>
            <span className={css.menuItemTitle}>
              <FormattedMessage id="TopbarDesktop.explore" />
            </span>
            <NamedLink
              name="SearchPage"
              to={{
                search: `address=Singapore&bounds=1.4110994%2C103.9577613%2C1.2642103%2C103.6055395&dates=${moment().format(
                  'YYYY-MM-DD'
                )},${moment().format('YYYY-MM-DD')}&times=00:00,23:59&pub_listing_type=class`,
              }}
            >
              <span className={css.menuItemClientInfoWithBackground}>
                <span className={css.menuOptionLabel}>
                  <FormattedMessage id="TopbarDesktop.dailyClass" />
                </span>
                <span>{svgIcon}</span>
              </span>
            </NamedLink>
            <NamedLink
              name="SearchPage"
              to={{
                search: 'pub_listing_type=listing',
              }}
            >
              <span className={css.menuItemClientInfoWithBackground}>
                <span className={css.menuOptionLabel}>
                  <FormattedMessage id="TopbarDesktop.searchPro" />
                </span>
                <span>{svgIcon}</span>
              </span>
            </NamedLink>
            {/* <div>
        <span className={css.menuItemClientInfoWithBackground}>
            <span className={css.menuOptionLabel}><FormattedMessage id="TopbarDesktop.popularServices" /></span>
            <span>{svgIcon}</span>
          </span>
        </div> */}
            <NamedLink
              name="SearchPage"
              to={{
                search: 'pub_listing_type=facility',
              }}
            >
              <span className={css.menuItemClientInfoWithBackground}>
                <span className={css.menuOptionLabel}>
                  <FormattedMessage id="TopbarDesktop.rentSpaces" />
                </span>
                <span>{svgIcon}</span>
              </span>
            </NamedLink>
            <NamedLink
              name="SearchPage"
              to={{
                search: 'pub_listing_type=listing',
              }}
            >
              <span className={css.menuItemBorder} />
              <span className={css.menuItemClientInfoWithBackground}>
                <span className={css.menuOptionLabel}>
                  <FormattedMessage id="TopbarDesktop.viewDeals" />
                </span>
                <span>{svgIcon}</span>
              </span>
            </NamedLink>
            <NamedLink
              name="SearchPage"
              to={{
                search: 'pub_listing_type=product',
              }}
            >
              <span className={css.menuItemBorder} />
              <span className={css.menuItemClientInfoWithBackground}>
                <span className={css.menuOptionLabel}>
                  <FormattedMessage id="TopbarDesktop.events" />
                </span>
                <span>{svgIcon}</span>
              </span>
            </NamedLink>
          </div>
        </div>
      )}
    </div>
  );

  const vendorPortal = (
    <div className={css.menucontent}>
      <div className={css.menuSection}>
        <div className={css.whiteContainer}>
          <div className={css.menuImage}>
            <img src={ImageVendorPortal} alt="ImageVendorPortal" />
          </div>
          {/* <div className={css.mobMenuTitle}><FormattedMessage id="TopbarDesktop.yourAccount" /></div> */}
          <NamedLink className={css.inboxMenuLink} name="InboxPage" params={{ tab: 'sales' }}>
            <div className={css.menuItemHolder}>
              <div>
                <IconBookings />
              </div>
              <div>
                <div className={css.notificationCountBadgeWrap}>
                  <span className={css.menuItemTitle}>
                    <FormattedMessage id="TopbarDesktop.inbox" />
                  </span>
                  {notificationCountBadge}
                </div>
                <span className={css.menuItemInfo}>
                  <FormattedMessage id="TopbarDesktop.bookingsAcceptRescheduleCancel" />
                </span>
              </div>
            </div>
          </NamedLink>
          <NamedLink
            className={css.inboxMenuLink}
            name="InboxPage"
            params={{ tab: 'sellerPackages' }}
          >
            <div className={css.menuItemHolder}>
              <div>
                <IconPackages />
              </div>
              <div>
                <span className={css.menuItemBorder} />
                <span className={css.menuItemTitle}>
                  <FormattedMessage id="TopbarDesktop.packagesSold" />
                </span>
                <span className={css.menuItemInfo}>
                  <FormattedMessage id="TopbarDesktop.packagesSoldInfo" />
                </span>
              </div>
            </div>
          </NamedLink>
          <NamedLink className={css.inboxMenuLink} name="InboxPage" params={{ tab: 'schedule' }}>
            <div className={css.menuItemHolder}>
              <div>
                <IconSchedule />
              </div>
              <div>
                <span className={css.menuItemTitle}>
                  <FormattedMessage id="TopbarDesktop.yourSchedule" />
                </span>
                <span className={css.menuItemInfo}>
                  <FormattedMessage id="TopbarDesktop.yourScheduleInfo" />
                </span>
              </div>
            </div>
          </NamedLink>
          <NamedLink className={css.inboxMenuLink} name="InboxPage" params={{ tab: 'myClients' }}>
            <div className={css.menuItemHolder}>
              <div>
                <IconClient />
              </div>
              <div>
                <span className={css.menuItemTitle}>
                  <FormattedMessage id="TopbarDesktop.yourClient" />
                </span>
                <span className={css.menuItemInfo}>
                  <FormattedMessage id="TopbarDesktop.yourClientInfo" />
                </span>
              </div>
            </div>
          </NamedLink>
          <NamedLink name="SubscriptionPage" className={css.menuItemHolder}>
            <div>
              <img src={'/static/images/Icons/subscription.png'} alt="subscription" />
            </div>
            <div className={css.inboxMenuLink}>
              <span className={css.menuItemBorder} />
              <span className={css.menuItemTitle}>
                <FormattedMessage id="TopbarDesktop.subscription" />
              </span>
              <span className={css.menuItemInfo}>
                <FormattedMessage id="TopbarDesktop.subscriptionInfo" />
              </span>
            </div>
          </NamedLink>
        </div>

        <div className={css.greyContainer}>
          <div className={css.menuSection}>
            <div className={css.menuImage}>
              <img src={ImageVendorPortal2} alt="ImageVendorPortal2" />
            </div>
            <div className={css.menuItemTitleAddListings}>
              <FormattedMessage id="TopbarDesktop.yourFitnessHealthListings" />
            </div>
            <NamedLink className={css.menuItemHeading} name="ManageListingsPage">
              <span className={css.titleManageEdit}>
                <FormattedMessage id="TopbarDesktop.manageAndEdit" />
              </span>
            </NamedLink>
            <NamedLink className={css.menuItemHeading} name="ManageListingsPage">
              <span className={css.titleManageEdit}>
                <FormattedMessage id="TopbarDesktop.shareBookingPage" />
              </span>
            </NamedLink>
            <NamedLink
              className={css.inboxMenuLink}
              to={{
                search: 'embed=true',
              }}
              name="ManageListingsPage"
            >
              <span className={css.titleManageEdit}>
                <FormattedMessage id="TopbarDesktop.embedPrivateListing" />
              </span>
            </NamedLink>
            <h3 className={css.menuItemTitleAddListings}>
              <FormattedMessage id="TopbarDesktop.addListings" />
            </h3>
            <NamedLink name="NewListingPage">
              <span className={css.displayMenu}>
                <span className={css.menuItemAddListingInfo}>
                  <span className={css.sessionsName}>
                    <FormattedMessage id="TopbarDesktop.addHostListing" />
                  </span>
                  <span>{svgIcon}</span>
                </span>
              </span>
            </NamedLink>
            <NamedLink name="NewClassPage">
              <span className={css.displayMenu}>
                <span className={css.menuItemAddListingInfo}>
                  <span className={css.sessionsName}>
                    <FormattedMessage id="TopbarDesktop.addClassListing" />
                  </span>
                  <span>{svgIcon}</span>
                </span>
              </span>
            </NamedLink>
            <NamedLink name="NewCompanyPage">
              <span className={css.menuItemBorder} />
              <span className={css.displayMenu}>
                <span className={css.menuItemAddListingInfo}>
                  <span className={css.sessionsName}>
                    <FormattedMessage id="TopbarDesktop.addCompanyPage" />
                  </span>
                  <span>{svgIcon}</span>
                </span>
              </span>
            </NamedLink>
            {/* <NamedLink name="NewMembershipPage">
              <span className={css.menuItemBorder} />
              <span className={css.displayMenu}>
                <span className={css.menuItemAddListingInfo}>
                  <span className={css.sessionsName}>
                    <FormattedMessage id="TopbarDesktop.createProduct" />
                  </span>
                  <span>{svgIcon}</span>
                </span>
              </span>
            </NamedLink> */}
            <NamedLink name="NewFacilityPage">
              <span className={css.menuItemBorder} />
              <span className={css.displayMenu}>
                <span className={css.menuItemAddListingInfo}>
                  <span className={css.sessionsName}>
                    <FormattedMessage id="TopbarDesktop.addFacility" />
                  </span>
                  <span>{svgIcon}</span>
                </span>
              </span>
            </NamedLink>
          </div>
        </div>
      </div>
    </div>
  );

  const becomeVendorPortal = (
    <div className={css.menucontent}>
      <div className={css.whiteContainer}>
        <div className={classNames(css.menuImage, css.becomeVendorMenuImage)}>
          <img src={ImagebecomeVendorPortal1} alt="ImagebecomeVendorPortal1" />
        </div>
        <NamedLink className={css.inboxMenuLink} name="BecomeVendorPage">
          <span className={classNames(css.becomeVenderTitle)}>
            <FormattedMessage id="TopbarDesktop.becomeHost" />
          </span>
          <span className={css.socialSearchMarketingInfo}>
            <FormattedMessage id="TopbarDesktop.becomeVendorInfo" />
          </span>
        </NamedLink>
      </div>
      <div className={css.greyContainer}>
        <div className={css.menuSection}>
          <div className={classNames(css.menuImage, css.becomeVendorMenuImage)}>
            <img src={ImagebecomeVendorPortal2} alt="ImagebecomeVendorPortal2" />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className={css.root}>
      <div className={css.topRoot}>
        {/*  */}

        <div className={css.content}>
          <div id="vendormenu"></div>
          <div className={css.portalHeadingWrapper} onClick={onClientMenuToggle}>
            <div className={css.menuImageContainer}>
              <img
                src={'/static/images/Icons/client_portal_mobile_menu.png'}
                alt="client portal mobile menu"
              />
            </div>
            <div className={css.cardContentWrapper}>
              <div className={css.portalHeading}>
                <FormattedMessage id={'TopbarMobileMenu.client'} />
                <span className={css.infoSpan}>
                  <FormattedMessage id={'TopbarMobileMenu.clientPortalInfo'} />
                </span>
              </div>
              <div className={css.menuIconWrapper}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                >
                  <circle cx="15.4434" cy="15.0635" r="14.5" fill="white" stroke="white" />
                  <path
                    d="M22.4485 18.6857C21.5558 17.7185 20.4725 16.9466 19.2668 16.4187C18.0611 15.8907 16.7591 15.6182 15.4429 15.6182C14.1267 15.6182 12.8248 15.8907 11.6191 16.4187C10.4134 16.9466 9.33007 17.7185 8.43737 18.6857C8.29955 18.8381 8.22245 19.0358 8.2207 19.2412V22.5746C8.22362 22.7937 8.31271 23.0028 8.46867 23.1567C8.62464 23.3106 8.83493 23.3968 9.05404 23.3968H21.8318C22.0528 23.3968 22.2648 23.309 22.4211 23.1527C22.5773 22.9964 22.6651 22.7845 22.6651 22.5635V19.2301C22.6607 19.0285 22.5838 18.8352 22.4485 18.6857V18.6857Z"
                    fill="#0095B3"
                  />
                  <path
                    d="M15.4436 14.5078C17.5914 14.5078 19.3325 12.7666 19.3325 10.6189C19.3325 8.4711 17.5914 6.72998 15.4436 6.72998C13.2958 6.72998 11.5547 8.4711 11.5547 10.6189C11.5547 12.7666 13.2958 14.5078 15.4436 14.5078Z"
                    fill="#0095B3"
                  />
                </svg>
              </div>
            </div>
          </div>
          {isClientMenuOpen && clientPortal}
          {!isPrivateSite && (
            <>
              <div>
                <div className={css.portalHeadingWrapper} onClick={onVendorMenuToggle}>
                  <div className={css.menuImageContainer}>
                    <img
                      src={'/static/images/Icons/vendor_portal_mobile_menu.png'}
                      alt="vendor_portal_mobile_menu"
                    />
                  </div>
                  <div className={css.cardContentWrapper}>
                    <div className={css.portalHeading}>
                      <div className={css.notificationCountBadgeWrapper}>
                        <FormattedMessage id={'TopbarMobileMenu.host'} />
                        {notificationCountBadge}
                      </div>
                      <span className={css.infoSpan}>
                        <FormattedMessage id={'TopbarMobileMenu.vendorPortalInfo'} />
                      </span>
                    </div>
                    <div className={css.menuIconWrapper}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="31"
                        height="31"
                        viewBox="0 0 31 31"
                        fill="none"
                      >
                        <circle cx="15.4434" cy="15.1055" r="14.5" fill="white" stroke="white" />
                        <path
                          d="M16.9605 23.4386H13.9272C13.7371 23.4387 13.5528 23.3737 13.4047 23.2546C13.2566 23.1355 13.1537 22.9693 13.113 22.7836L12.7738 21.2136C12.3214 21.0154 11.8924 20.7675 11.4947 20.4745L9.96383 20.962C9.78264 21.0198 9.58712 21.0138 9.40977 20.9452C9.23241 20.8765 9.08388 20.7492 8.98883 20.5845L7.46883 17.9586C7.37479 17.7938 7.33948 17.6018 7.3687 17.4143C7.39792 17.2267 7.48992 17.0546 7.62967 16.9261L8.81717 15.8428C8.76316 15.3521 8.76316 14.8569 8.81717 14.3661L7.62967 13.2853C7.48973 13.1568 7.39759 12.9845 7.36837 12.7968C7.33915 12.609 7.37457 12.4169 7.46883 12.252L8.9855 9.62447C9.08054 9.45974 9.22908 9.33247 9.40643 9.2638C9.58379 9.19513 9.7793 9.18919 9.9605 9.24697L11.4913 9.73447C11.6947 9.58447 11.9063 9.44447 12.1247 9.31781C12.3355 9.19947 12.5522 9.09197 12.7738 8.99614L13.1138 7.42781C13.1543 7.24214 13.257 7.07588 13.405 6.9566C13.5529 6.83731 13.7371 6.77217 13.9272 6.77197H16.9605C17.1505 6.77217 17.3348 6.83731 17.4827 6.9566C17.6306 7.07588 17.7334 7.24214 17.7738 7.42781L18.1172 8.99697C18.3505 9.10031 18.5788 9.21614 18.7997 9.34531C19.0055 9.46447 19.2047 9.59531 19.3963 9.73614L20.928 9.24864C21.1091 9.19107 21.3044 9.19711 21.4816 9.26577C21.6588 9.33443 21.8072 9.46158 21.9022 9.62614L23.4188 12.2536C23.6122 12.5928 23.5455 13.022 23.258 13.2861L22.0705 14.3695C22.1245 14.8602 22.1245 15.3554 22.0705 15.8461L23.258 16.9295C23.5455 17.1945 23.6122 17.6228 23.4188 17.962L21.9022 20.5895C21.8071 20.7542 21.6586 20.8815 21.4812 20.9502C21.3039 21.0188 21.1084 21.0248 20.9272 20.967L19.3963 20.4795C18.9989 20.7723 18.5702 21.0199 18.118 21.2178L17.7738 22.7836C17.7332 22.9692 17.6304 23.1352 17.4825 23.2543C17.3346 23.3735 17.1504 23.4385 16.9605 23.4386ZM15.4405 11.772C14.5564 11.772 13.7086 12.1232 13.0835 12.7483C12.4584 13.3734 12.1072 14.2213 12.1072 15.1053C12.1072 15.9894 12.4584 16.8372 13.0835 17.4623C13.7086 18.0875 14.5564 18.4386 15.4405 18.4386C16.3246 18.4386 17.1724 18.0875 17.7975 17.4623C18.4226 16.8372 18.7738 15.9894 18.7738 15.1053C18.7738 14.2213 18.4226 13.3734 17.7975 12.7483C17.1724 12.1232 16.3246 11.772 15.4405 11.772Z"
                          fill="#3DD170"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {isVendorMenuOpen && vendorPortal}
              </div>

              <div>
                <div className={css.portalHeadingWrapper} onClick={onBecomeVendorMenuToggle}>
                  <div className={css.menuImageContainer}>
                    <img
                      src={'/static/images/Icons/become_vendor_portal_mobile_menu.png'}
                      alt="become vendor portal mobile menu"
                    />
                  </div>
                  <div className={css.cardContentWrapper}>
                    <div className={css.portalHeading}>
                      <FormattedMessage id={'TopbarMobileMenu.exploreHosting'} />
                      <span className={css.infoSpan}>
                        <FormattedMessage id={'TopbarMobileMenu.becomeVendorInfo'} />
                      </span>
                    </div>
                    <div className={css.menuIconWrapper}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="31"
                        height="31"
                        viewBox="0 0 31 31"
                        fill="none"
                      >
                        <circle cx="15.4434" cy="15.6885" r="14.5" fill="white" stroke="white" />
                        <path
                          d="M21.485 10.726V10.4801C21.485 9.87236 21.2436 9.28946 20.8138 8.85969C20.384 8.42992 19.8011 8.18848 19.1934 8.18848H9.81836C9.56099 8.18852 9.30639 8.24155 9.07041 8.34425C8.83443 8.44696 8.62212 8.59715 8.44669 8.78547C8.27127 8.97379 8.1365 9.19621 8.05077 9.43887C7.96503 9.68154 7.93017 9.93925 7.94836 10.196C7.94517 10.2211 7.9435 10.2465 7.94336 10.2718V20.4801C7.94336 21.1984 8.2287 21.8873 8.73661 22.3952C9.24452 22.9031 9.9334 23.1885 10.6517 23.1885H21.0684C21.6761 23.1885 22.259 22.947 22.6888 22.5173C23.1186 22.0875 23.36 21.5046 23.36 20.8968V12.9801C23.3602 12.4445 23.1727 11.9258 22.8302 11.514C22.4877 11.1022 22.0117 10.8234 21.485 10.726ZM9.81836 9.43848H19.1934C19.7684 9.43848 20.235 9.90514 20.235 10.4801V10.6885H9.81836C9.6526 10.6885 9.49363 10.6226 9.37642 10.5054C9.25921 10.3882 9.19336 10.2292 9.19336 10.0635C9.19336 9.89772 9.25921 9.73874 9.37642 9.62153C9.49363 9.50432 9.6526 9.43848 9.81836 9.43848ZM18.985 16.5218H20.6517C20.8175 16.5218 20.9764 16.5877 21.0936 16.7049C21.2108 16.8221 21.2767 16.981 21.2767 17.1468C21.2767 17.3126 21.2108 17.4715 21.0936 17.5888C20.9764 17.706 20.8175 17.7718 20.6517 17.7718H18.985C18.8193 17.7718 18.6603 17.706 18.5431 17.5888C18.4259 17.4715 18.36 17.3126 18.36 17.1468C18.36 16.981 18.4259 16.8221 18.5431 16.7049C18.6603 16.5877 18.8193 16.5218 18.985 16.5218Z"
                          fill="#0095B3"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {isBecomeVendorMenuOpen && becomeVendorPortal}
              </div>
            </>
          )}
        </div>
      </div>
      {!isPrivateSite && (
        <Slider {...sliderSettings} className={css.slider}>
          <section className={css.connectPros}>
            <h4 className={css.connectProsTitle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="18"
                viewBox="0 0 11 18"
                fill="none"
              >
                <path
                  d="M4.5 10H0L8.21429 0L6.5 7.5H10.5L1.78571 18L4.5 10Z"
                  fill="url(#paintTopbarMobileMenu_linear_4633_167)"
                />
                <defs>
                  <linearGradient
                    id="paintTopbarMobileMenu_linear_4633_167"
                    x1="5"
                    y1="2.42782e-09"
                    x2="-3.48706"
                    y2="17.1585"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#10D6EB" />
                    <stop offset="1" stopColor="#0095B3" />
                  </linearGradient>
                </defs>
              </svg>
              <FormattedMessage id="LandingPage.getMatchesFaster" />
            </h4>
            <span className={css.startRequestFormDescription}>
              <FormattedMessage id="LandingPage.PostRequest" />
              <FormattedMessage id="LandingPage.connectPros" />
            </span>
            <NamedLink name="NewInquirePage" className={css.startRequestFormButton}>
              <FormattedMessage id="LandingPage.tryProConnect" />
            </NamedLink>
          </section>

          <section className={css.connectPros}>
            <h4 className={css.connectProsTitle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="16"
                viewBox="0 0 10 16"
                fill="none"
              >
                <path
                  d="M3.98407 8.82603H0.207031L7.10162 0.432617L5.66275 6.72768H9.02011L1.70586 15.5408L3.98407 8.82603Z"
                  fill="url(#paint0_linear_4664_53)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_4664_53"
                    x1="4.40374"
                    y1="0.432617"
                    x2="-2.7198"
                    y2="14.8344"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#FF385C" />
                    <stop offset="1" stopColor="#0095B3" />
                  </linearGradient>
                </defs>
              </svg>
              <FormattedMessage id="TopbarDesktop.startEarningToday" />
            </h4>
            <span className={css.startRequestFormDescription}>
              <FormattedMessage id="LandingPage.PostRequest" />
              <FormattedMessage id="LandingPage.connectPros" />
            </span>
            <NamedLink
              name="BecomeVendorPage"
              className={classNames(css.startRequestFormButton, css.redText)}
            >
              <FormattedMessage id="TopbarDesktop.becomeAHost" />
            </NamedLink>
          </section>
        </Slider>
      )}

      <div>
        {isAuthenticated && (
          <>
            {/* <div className={css.avatarImageDetailSection}> */}
            {/* <div className={css.profileInfoContainer}> */}
            <div className={css.settingBtnWrapper}>
              <Button rootClassName={css.bookButton} onClick={onProfileMenuToggle}>
                <FormattedMessage id="TopbarMobileMenu.settings" />
              </Button>
              <NamedLink name="ProfileSettingsPage" className={css.editProfile}>
                <FormattedMessage id="TopbarMobileMenu.editProfile" />
              </NamedLink>
            </div>
            {/* </div> */}
            {/* </div> */}
            <div className={css.profileMenuWrapper}>{isProfileMenuOpen && profileMenu}</div>
          </>
        )}

        {!isAuthenticated && (
          <div id="clientmenu" className={classNames(css.avatarSection, css.portalHeading)}>
            <FormattedMessage
              id="TopbarMobileMenu.unauthorizedGreeting"
              values={{ lineBreak: <br />, signupOrLogin }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

TopbarMobileMenu.defaultProps = {
  currentUser: null,
  notificationCount: 0,
  currentPage: null,
};

TopbarMobileMenu.propTypes = {
  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  currentPage: string,
  notificationCount: number,
  onLogout: func.isRequired,
};

export default TopbarMobileMenu;
